export enum EnumSubscription {
    /** Starting 15 days free trial*/
    TRIAL, 
    /** User ends the trial or the PRO plan */
    BASIC,
    /** User has the pro plan */
    PRO
}